var map = {
	"./add-circle.svg": [
		2116,
		16
	],
	"./amex.svg": [
		2117,
		17
	],
	"./arrow-down-regular.svg": [
		2118,
		18
	],
	"./arrow-down.svg": [
		2119,
		19
	],
	"./arrow-left.svg": [
		2120,
		20
	],
	"./arrow-right-plain.svg": [
		2121,
		21
	],
	"./arrow-right.svg": [
		2122,
		22
	],
	"./arrow-up.svg": [
		2123,
		23
	],
	"./bag.svg": [
		2124,
		24
	],
	"./bank.svg": [
		2125,
		25
	],
	"./bubble-chat.svg": [
		2126,
		26
	],
	"./bulb.svg": [
		2127,
		27
	],
	"./calendar-alt.svg": [
		2128,
		28
	],
	"./calendar.svg": [
		2129,
		29
	],
	"./camera.svg": [
		2130,
		30
	],
	"./card-2.svg": [
		2131,
		31
	],
	"./card-plain.svg": [
		2132,
		32
	],
	"./card.svg": [
		2133,
		33
	],
	"./check-complete.svg": [
		2134,
		34
	],
	"./check-plain.svg": [
		2135,
		35
	],
	"./check-thin.svg": [
		2136,
		36
	],
	"./check.svg": [
		2137,
		37
	],
	"./checkbox.svg": [
		2138,
		38
	],
	"./closed-pot.svg": [
		2139,
		39
	],
	"./cross-single.svg": [
		2140,
		40
	],
	"./cross.svg": [
		2141,
		41
	],
	"./crown.svg": [
		2142,
		42
	],
	"./cvv.svg": [
		2143,
		43
	],
	"./dashboard-plain.svg": [
		2144,
		44
	],
	"./detective.svg": [
		2145,
		45
	],
	"./download-2.svg": [
		2146,
		46
	],
	"./download.svg": [
		2147,
		47
	],
	"./drinks.svg": [
		2148,
		48
	],
	"./edit-2.svg": [
		2149,
		49
	],
	"./edit.svg": [
		2150,
		50
	],
	"./envelope.svg": [
		2151,
		51
	],
	"./fat-arrow-bottom.svg": [
		2152,
		52
	],
	"./favorite.svg": [
		2153,
		53
	],
	"./fb.svg": [
		2154,
		54
	],
	"./folder-plain.svg": [
		2155,
		55
	],
	"./geoloc-outline.svg": [
		2156,
		56
	],
	"./geoloc-plain.svg": [
		2157,
		57
	],
	"./gift.svg": [
		2158,
		58
	],
	"./group.svg": [
		2159,
		59
	],
	"./heart.svg": [
		2160,
		60
	],
	"./hipster.svg": [
		2161,
		61
	],
	"./home.svg": [
		2162,
		62
	],
	"./house.svg": [
		2163,
		63
	],
	"./icon-pdf.svg": [
		2164,
		64
	],
	"./info.svg": [
		2165,
		65
	],
	"./invite.svg": [
		2166,
		66
	],
	"./invoice-plain.svg": [
		2167,
		67
	],
	"./life-ring-plain.svg": [
		2168,
		68
	],
	"./location.svg": [
		2169,
		69
	],
	"./lock-2.svg": [
		2170,
		70
	],
	"./lock.svg": [
		2171,
		71
	],
	"./locked.svg": [
		2172,
		72
	],
	"./logout-2.svg": [
		2173,
		73
	],
	"./logout.svg": [
		2174,
		74
	],
	"./luggage.svg": [
		2175,
		75
	],
	"./maestro.svg": [
		2176,
		76
	],
	"./martini.svg": [
		2177,
		77
	],
	"./mastercard-logo.svg": [
		2178,
		78
	],
	"./minus-single.svg": [
		2179,
		79
	],
	"./minus.svg": [
		2180,
		80
	],
	"./mug-heart.svg": [
		2181,
		81
	],
	"./office-plain.svg": [
		2182,
		82
	],
	"./opened-pot.svg": [
		2183,
		83
	],
	"./pdf-file.svg": [
		2184,
		84
	],
	"./pencil-outline.svg": [
		2185,
		85
	],
	"./pencil.svg": [
		2186,
		86
	],
	"./phone.svg": [
		2187,
		87
	],
	"./pin-outline.svg": [
		2188,
		88
	],
	"./pin.svg": [
		2189,
		89
	],
	"./plus-bold.svg": [
		2190,
		90
	],
	"./plus-plain.svg": [
		2191,
		91
	],
	"./plus-single-bold.svg": [
		2192,
		92
	],
	"./plus-single.svg": [
		2193,
		93
	],
	"./plus.svg": [
		2194,
		94
	],
	"./pos-ticket.svg": [
		2195,
		95
	],
	"./pot.svg": [
		2196,
		96
	],
	"./present.svg": [
		2197,
		97
	],
	"./pushchair.svg": [
		2198,
		98
	],
	"./quotes-down.svg": [
		2199,
		99
	],
	"./quotes-up.svg": [
		2200,
		100
	],
	"./rating-active.svg": [
		2201,
		101
	],
	"./rating.svg": [
		2202,
		102
	],
	"./red-warning.svg": [
		2203,
		103
	],
	"./redesign/add-circle.svg": [
		2204,
		104
	],
	"./redesign/admin.svg": [
		2205,
		105
	],
	"./redesign/arrow-left.svg": [
		2206,
		106
	],
	"./redesign/arrow-right.svg": [
		2207,
		107
	],
	"./redesign/avekapeti.svg": [
		2208,
		108
	],
	"./redesign/backArrow.svg": [
		2209,
		109
	],
	"./redesign/basket.svg": [
		2210,
		110
	],
	"./redesign/card.svg": [
		2211,
		111
	],
	"./redesign/check.svg": [
		2212,
		112
	],
	"./redesign/close.svg": [
		2213,
		113
	],
	"./redesign/credit-card.svg": [
		2214,
		114
	],
	"./redesign/deliveroo.svg": [
		2215,
		115
	],
	"./redesign/donation.svg": [
		2216,
		116
	],
	"./redesign/eye-reversed.svg": [
		2217,
		117
	],
	"./redesign/eye.svg": [
		2218,
		118
	],
	"./redesign/filter.svg": [
		2219,
		119
	],
	"./redesign/gift.svg": [
		2220,
		120
	],
	"./redesign/help-outline.svg": [
		2221,
		121
	],
	"./redesign/help.svg": [
		2222,
		122
	],
	"./redesign/info-circle.svg": [
		2223,
		123
	],
	"./redesign/info-plain.svg": [
		2224,
		124
	],
	"./redesign/info.svg": [
		2225,
		125
	],
	"./redesign/left-arrow.svg": [
		2226,
		126
	],
	"./redesign/location.svg": [
		2227,
		127
	],
	"./redesign/lunchr-app-topup.svg": [
		2228,
		128
	],
	"./redesign/lunchr-app.svg": [
		2229,
		129
	],
	"./redesign/lunchr-card-monext-topup.svg": [
		2230,
		130
	],
	"./redesign/lunchr-card-monext.svg": [
		2231,
		131
	],
	"./redesign/lunchr-card-topup.svg": [
		2232,
		132
	],
	"./redesign/lunchr-card.svg": [
		2233,
		133
	],
	"./redesign/manager.svg": [
		2234,
		134
	],
	"./redesign/more.svg": [
		2235,
		135
	],
	"./redesign/party-popper.svg": [
		2236,
		136
	],
	"./redesign/paygreen.svg": [
		2237,
		137
	],
	"./redesign/pencil-reversed.svg": [
		2238,
		138
	],
	"./redesign/plus-purple.svg": [
		2239,
		139
	],
	"./redesign/plus-white.svg": [
		2240,
		140
	],
	"./redesign/plus.svg": [
		2241,
		141
	],
	"./redesign/right-arrow.svg": [
		2242,
		142
	],
	"./redesign/search.svg": [
		2243,
		143
	],
	"./redesign/seazon.svg": [
		2244,
		144
	],
	"./redesign/small-basket.svg": [
		2245,
		145
	],
	"./redesign/small-card.svg": [
		2246,
		146
	],
	"./redesign/small-location.svg": [
		2247,
		147
	],
	"./redesign/store.svg": [
		2248,
		148
	],
	"./redesign/swile-app-topup.svg": [
		2249,
		149
	],
	"./redesign/swile-app.svg": [
		2250,
		150
	],
	"./redesign/tick.svg": [
		2251,
		151
	],
	"./redesign/toggle-down.svg": [
		2252,
		152
	],
	"./redesign/toggle-up.svg": [
		2253,
		153
	],
	"./redesign/tooltip-trigger-white.svg": [
		2254,
		154
	],
	"./redesign/tooltip-trigger.svg": [
		2255,
		155
	],
	"./redesign/uber-eats.svg": [
		2256,
		156
	],
	"./redo.svg": [
		2257,
		157
	],
	"./remove-plain.svg": [
		2258,
		158
	],
	"./remove.svg": [
		2259,
		159
	],
	"./roulette-arrow.svg": [
		2260,
		160
	],
	"./s-batman.svg": [
		2261,
		161
	],
	"./s-captain-america.svg": [
		2262,
		162
	],
	"./s-catwoman.svg": [
		2263,
		163
	],
	"./s-green-lantern.svg": [
		2264,
		164
	],
	"./s-ninja-turtle.svg": [
		2265,
		165
	],
	"./s-robotcop.svg": [
		2266,
		166
	],
	"./s-spiderman.svg": [
		2267,
		167
	],
	"./s-stormtrooper.svg": [
		2268,
		168
	],
	"./s-the-flash.svg": [
		2269,
		169
	],
	"./s-wolverine.svg": [
		2270,
		170
	],
	"./s-wonderwoman.svg": [
		2271,
		171
	],
	"./search.svg": [
		2272,
		172
	],
	"./selectors.svg": [
		2273,
		173
	],
	"./special-alert-solid.svg": [
		2274,
		174
	],
	"./store.svg": [
		2275,
		175
	],
	"./ticket.svg": [
		2276,
		176
	],
	"./trash-outline.svg": [
		2277,
		177
	],
	"./trash.svg": [
		2278,
		178
	],
	"./twitter-bird.svg": [
		2279,
		179
	],
	"./undo.svg": [
		2280,
		180
	],
	"./user-circle-plain.svg": [
		2281,
		181
	],
	"./user.svg": [
		2282,
		182
	],
	"./valid.svg": [
		2283,
		183
	],
	"./view.svg": [
		2284,
		184
	],
	"./visa-logo.svg": [
		2285,
		185
	],
	"./walk.svg": [
		2286,
		186
	],
	"./warning.svg": [
		2287,
		187
	],
	"./whatsapp-icon.svg": [
		2288,
		188
	],
	"./withdrawal.svg": [
		2289,
		189
	],
	"./zoom-file.svg": [
		2290,
		190
	],
	"./zoom.svg": [
		2291,
		191
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1714;
module.exports = webpackAsyncContext;